<template>
	<button type="button" class="resource-planning-add-member">
		<SuiIcon :name="iconName" class="resource-planning-add-member__icon" />
		{{ text }}
	</button>
</template>

<script setup lang="ts">
import { SuiIcon } from '@developers/scoro-ui';

export interface ResourcePlanningAddMember {
	text: string;
	iconName: string;
}
/**
 * !!! IMPORTANT !!!
 * this is a html/css only component used for rendering
 * no business logic JS will work
 */

defineProps<ResourcePlanningAddMember>();
</script>

<style lang="scss">
.resource-planning-add-member {
	width: 100%;
	height: 100%;
	display: inline-flex;
	gap: 0.5rem;
	color: $neutral-70;
	vertical-align: middle;

	&__icon {
		margin-top: -0.25rem;
	}
}
</style>
